/**
 * Janela (<Dialog> Radix) que chama o modal global (modal.confirm/error) por cima de si.
 *
 * O modal global (ModalHost) fica FORA da janela: sem isto, clicar em "Cancelar"/"Entendi" dele
 * conta como clique fora da janela e o Esc dele também chega à janela — as duas coisas fechavam a
 * janela de baixo e o que estava digitado se perdia. Use no <DialogContent {...protegeDoModalGlobal}>.
 */
const dentroDoModalGlobal = (e) => {
  const alvo = e?.detail?.originalEvent?.target || e?.target;
  return !!(alvo && typeof alvo.closest === "function" && alvo.closest(".modal-overlay"));
};
const modalGlobalAberto = () => typeof document !== "undefined" && !!document.querySelector(".modal-overlay");

export const protegeDoModalGlobal = {
  onInteractOutside: (e) => { if (dentroDoModalGlobal(e) || modalGlobalAberto()) e.preventDefault(); },
  onEscapeKeyDown: (e) => { if (modalGlobalAberto()) e.preventDefault(); },
};
